import { Component, Input, OnInit } from '@angular/core';
import {invertColor, lighten} from '../../utilities'
@Component({
  selector: 'avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.css']
})
export class AvatarComponent implements OnInit {
  @Input() color: string = "black"
  textColor: string
  constructor() { }

  ngOnInit(): void {
    this.color = lighten(this.color, 8)
    this.textColor = invertColor(this.color)
  
  }
}
